import { RvTruckIcon } from './RvTruckIcon';

/**
 * author: Michael Richins
 * id 43C3E250-2842-4973-8D19-CA1E48BCF61C
 * name rv-truck
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rv-truck.svg
 * tags
 * - Transportation + Road 
 */
export const RecreationalVehicleIcon = RvTruckIcon;
export default RecreationalVehicleIcon